<template>
  <bvue-ui-view class="flex flex-col">
    <div class="flex items-center">
      <h1>Ecosistemas</h1>
      <div class="flex-1 flex justify-end">
        <button @click="add" class="btn btn-primary">Añadir</button>
      </div>
    </div>
    <p>Pulsa en la fila para editar</p>
    <div class="flex-1 overflow-scroll relative">
      <sortable-table :items="items" :columns="columns" startSort="id" @rowSelected="rowSelected"/>
    </div>
  </bvue-ui-view>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import firebase from '@/firebase'
import SortableTable from '@/components/SortableTable'
import EcosystemDetails from '@/pages/admin/EcosystemDetails'
export default {
  name: 'Ecosystems',
  data() {
    return {
      columns: [
        {
          key: 'name',
          name: 'nombre',
          align: 'left',
          sortable: true,
          type: 'text'
        },
        {
          key: 'description',
          name: 'description',
          align: 'left',
          sortable: true,
          type: 'text'
        }
      ],
      sort: 'id',
      order: 'asc'
    }
  },
  components: {
    SortableTable
  },
  computed: {
    items() {
      var response = []
      const itemsObj = this.$store.state.ecosystems.items
      for (const key in itemsObj) {
          response.push(itemsObj[key])
      }
      return response
    }
  },
  methods: {
    add() {
      this.showDetails()
    },
    rowSelected(args) {
      if (args.length > 1) {
        const item = args[1]
        this.showDetails(item)
      }
    },
    showDetails(item) {
      this.$bvueUi.modal.show({
        component: EcosystemDetails,
        width: 800,
        height: 800,
        data: item
      })
    }
  },
  created() {
    
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/Ecosystems.vue